module.exports = __webpack_public_path__ + "img/7_6.ef4499af.png";